<div class="navigation-items action-items">
  <div class="action-icon" *ngIf="isAPT" (click)="triggerAction('buttonSearchPropertiesForPortfolio')" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/bag-add-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.buttonAddPropertyToProject' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonAddPropertyToProject' | translate | uppercase"></div>
  </div>
  <div class="action-icon" (click)="setinfoBarVisibility()" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/images-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.buttonInfoMode' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonInfoMode' | translate | uppercase"></div>
  </div>
  <div *ngIf="displaySaveCancelActions" class="action-icon" (click)="saveCancelActions('savePropertyData')" [class.disabled]="saveInProgress">
    <svg-icon src='./assets/icons/save.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.save' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.save' | translate | uppercase}}</div>
  </div>
  <div *ngIf="displaySaveCancelActions" class="action-icon" (click)="saveCancelActions('cancelPropertyDataChanges')">
    <svg-icon src='./assets/icons/close-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.cancel' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.cancel' | translate | uppercase}}</div>
  </div>
  <div class="action-icon" (click)="exportToExcel()" *ngIf="isAdminUser && !displaySaveCancelActions">
    <svg-icon src='./assets/icons/download_export.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.exportToExcel' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label-three-words">{{'projectToolbar.exportToExcel' | translate | uppercase}}</div>
  </div>
</div>
